import React from 'react'
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';

const CanTabing = ({value}) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider',mb:3 }}>
        <Button className={`tabingButton ${value === 'constant-messages' ? 'Mui-selected' : ''}`} component={Link} to="/can/constant-messages">ECU Constant TxMessages</Button>
        <Button className={`tabingButton ${value === 'definitions' ? 'Mui-selected' : ''}`} component={Link} to="/can/definitions">ECUID Definitions</Button>
        <Button className={`tabingButton ${value === 'request-pgn' ? 'Mui-selected' : ''}`} component={Link} to="/can/request-pgn">ECU Request PGN</Button>
        <Button className={`tabingButton ${value === 'receive-messages' ? 'Mui-selected' : ''}`} component={Link} to="/can/receive-messages">ECU Receive Messages</Button>
        <Button className={`tabingButton ${value === 'transmit-messages' ? 'Mui-selected' : ''}`} component={Link} to="/can/transmit-messages">ECU Transmit Messages</Button>
    </Box>
  )
}

export default CanTabing